//Material Icons available here: https://marella.me/material-symbols/demo/

import add_image from "@material-symbols/svg-600/rounded/add_photo_alternate.svg"
import photo from "@material-symbols/svg-600/rounded/panorama.svg"
import home from "@material-symbols/svg-600/rounded/home.svg"
import left from "@material-symbols/svg-600/rounded/keyboard_arrow_left.svg"
import right from "@material-symbols/svg-600/rounded/keyboard_arrow_right.svg"
import expand_right from "@material-symbols/svg-600/rounded/arrow_right.svg"
import expand_down from "@material-symbols/svg-600/rounded/arrow_drop_down.svg"
import up from "@material-symbols/svg-600/rounded/keyboard_arrow_up.svg"
import down from "@material-symbols/svg-600/rounded/keyboard_arrow_down.svg"
import folder from "@material-symbols/svg-600/rounded/folder.svg"
import folder_fill from "@material-symbols/svg-600/rounded/folder-fill.svg"
import grid_view from "@material-symbols/svg-600/rounded/grid_view.svg"
import focus from "@material-symbols/svg-600/rounded/capture.svg"
import undo from "@material-symbols/svg-600/rounded/undo.svg"
import redo from "@material-symbols/svg-600/rounded/redo.svg"
import download from "@material-symbols/svg-600/rounded/download.svg"
import star from "@material-symbols/svg-600/rounded/star.svg"
import star_fill from "@material-symbols/svg-600/rounded/star-fill.svg"
import reset from "@material-symbols/svg-600/rounded/restart_alt.svg"
import add from "@material-symbols/svg-600/rounded/add.svg"
import remove from "@material-symbols/svg-600/rounded/remove.svg"
import history from "@material-symbols/svg-600/rounded/history.svg"
import check from "@material-symbols/svg-600/rounded/check.svg"
import indeterminate from "@material-symbols/svg-600/rounded/check_indeterminate_small.svg"
import upload from "@material-symbols/svg-600/rounded/upload.svg"
import calibrate from "@material-symbols/svg-600/rounded/av_timer.svg"
import adjust from "@material-symbols/svg-600/rounded/tune.svg"
import permission from "@material-symbols/svg-600/rounded/back_hand.svg"
import crop from "@material-symbols/svg-600/rounded/crop.svg"
import rotate_left from "@material-symbols/svg-600/rounded/rotate_left.svg"
import rotate_right from "@material-symbols/svg-600/rounded/rotate_right.svg"
import rotate_90_degrees_ccw from "@material-symbols/svg-600/rounded/rotate_90_degrees_ccw.svg"
import rotate_90_degrees_cw from "@material-symbols/svg-600/rounded/rotate_90_degrees_cw.svg"
import flip_x from "@material-symbols/svg-600/rounded/flip.svg"
import lock from "@material-symbols/svg-600/rounded/lock-fill.svg"
import lock_open from "@material-symbols/svg-600/rounded/lock_open.svg"
import sort from "@material-symbols/svg-600/rounded/sort.svg"
import check_circle from "@material-symbols/svg-600/rounded/check_circle-fill.svg"
import more from "@material-symbols/svg-600/rounded/more_horiz-fill.svg"
import news from "@material-symbols/svg-600/rounded/palette.svg"
import tutorials from "@material-symbols/svg-600/rounded/school.svg"
import support from "@material-symbols/svg-600/rounded/support.svg"
import projects from "@material-symbols/svg-600/rounded/hard_drive.svg"
import keyboard from "@material-symbols/svg-600/rounded/keyboard.svg"
import hidden from "@material-symbols/svg-600/rounded/visibility_off.svg"
import visible from "@material-symbols/svg-600/rounded/visibility.svg"
import copy from "@material-symbols/svg-600/rounded/copy_all.svg"
import error from "@material-symbols/svg-600/rounded/error.svg"
import icon_delete from "@material-symbols/svg-600/rounded/delete.svg"
import fullscreen from "@material-symbols/svg-600/rounded/fullscreen.svg"
import settings from "@material-symbols/svg-600/rounded/settings.svg"
import no_color from "@material-symbols/svg-600/rounded/do_not_disturb_on.svg"
import no_color_filled from "@material-symbols/svg-600/rounded/do_not_disturb_on-fill.svg"
import camera from "@material-symbols/svg-600/rounded/photo_camera.svg"
import invert_mask from "@material-symbols/svg-600/rounded/filter_b_and_w.svg"
import masking from "@material-symbols/svg-600/rounded/filter_tilt_shift.svg"
import radial_mask from "@material-symbols/svg-600/rounded/adjust.svg"
import gradient_mask from "@material-symbols/svg-600/rounded/gradient.svg"
import sky_mask from "@material-symbols/svg-600/rounded/wallpaper.svg"
import brush_mask from "@material-symbols/svg-600/rounded/brush.svg"
import brush_erase_mask from "@material-symbols/svg-600/rounded/ink_eraser.svg"
import background_mask from "@material-symbols/svg-600/rounded/background_replace.svg"
import subject_mask from "@material-symbols/svg-600/rounded/frame_person.svg"
import people_mask from "@material-symbols/svg-600/outlined/group.svg"
import add_mask from "@material-symbols/svg-600/rounded/shadow_add.svg"
import subtract_mask from "@material-symbols/svg-600/rounded/shadow_minus.svg"
import warning from "@material-symbols/svg-600/rounded/warning.svg"
import center_mark from "@material-symbols/svg-600/rounded/align_flex_center.svg"
import install_desktop from "@material-symbols/svg-600/rounded/install_desktop.svg"
import manual from "@material-symbols/svg-600/rounded/back_hand.svg"
import rename from "@material-symbols/svg-600/rounded/edit.svg"
import cull from "@material-symbols/svg-600/rounded/cleaning_services.svg"
import eye from "@material-symbols/svg-600/rounded/eye_tracking.svg"
import help from "@material-symbols/svg-600/rounded/help.svg"
import stacks from "@material-symbols/svg-600/rounded/stacks.svg"
import drag from "@material-symbols/svg-600/rounded/drag_indicator.svg"
import rated from "@material-symbols/svg-600/rounded/radio_button_checked.svg"
import thumb_up from "@material-symbols/svg-600/rounded/thumb_up-fill.svg"
import thumb_down from "@material-symbols/svg-600/rounded/thumb_down-fill.svg"
import kid_star from "@material-symbols/svg-600/rounded/kid_star-fill.svg"
import light from "@material-symbols/svg-600/rounded/light_mode.svg"
import close from "@material-symbols/svg-600/rounded/close.svg"
import list from "@material-symbols/svg-600/rounded/list.svg"
import list_sort from "@material-symbols/svg-600/rounded/swap_vert.svg"
import search from "@material-symbols/svg-600/rounded/search.svg"
import play from "@material-symbols/svg-600/rounded/play_arrow-fill.svg"
import arrow_up from "@material-symbols/svg-600/rounded/arrow_upward.svg"
import arrow_down from "@material-symbols/svg-600/rounded/arrow_downward.svg"
import arrow_back from "@material-symbols/svg-600/rounded/arrow_back.svg"
import arrow_forward from "@material-symbols/svg-600/rounded/arrow_forward.svg"
import info from "@material-symbols/svg-600/rounded/info.svg"
import filter from "@material-symbols/svg-600/rounded/filter_alt.svg"
import no_photo from "@material-symbols/svg-600/rounded/no_photography.svg"
import open_in_new from "@material-symbols/svg-600/rounded/open_in_new.svg"
import faces from "@material-symbols/svg-600/rounded/familiar_face_and_zone.svg"
import refresh from "@material-symbols/svg-600/rounded/refresh.svg"

// Custom icons
import backward from "./custom/backward.svg"
import forward from "./custom/forward.svg"
import to_front from "./custom/to_front.svg"
import to_back from "./custom/to_back.svg"
import splitscreen_right from "./custom/splitscreen_right.svg"
import compare from "./custom/compare.svg"
import presets from "./custom/presets.svg"
import film from "./custom/film.svg"
import diamond from "./custom/diamond.svg"
import locked from "./custom/locked.svg"
import parametric_curves from "./custom/parametric_curves.svg"
import star0 from "./custom/star0.svg"
import star1 from "./custom/star1.svg"
import star2 from "./custom/star2.svg"
import star3 from "./custom/star3.svg"
import star4 from "./custom/star4.svg"
import star5 from "./custom/star5.svg"
import star0_filled from "./custom/star0filled.svg"
import star1_filled from "./custom/star1filled.svg"
import star2_filled from "./custom/star2filled.svg"
import star3_filled from "./custom/star3filled.svg"
import star4_filled from "./custom/star4filled.svg"
import star5_filled from "./custom/star5filled.svg"
import move_left from "./custom/move_left.svg"
import move_right from "./custom/move_right.svg"
import youtube from "./custom/youtube.svg"
import format from "./custom/format.svg"
import style from "./custom/style.svg"
import color_clipping from "./custom/color_clipping.svg"
import pipette from "./custom/pipette.svg"
import healing from "./custom/healing.svg"
import healing_selected from "./custom/healing_selected.svg"
import unflagged from "./custom/unflagged.svg"
import flagged from "./custom/flagged.svg"
import rejected from "./custom/rejected.svg"
import unsupported from "./custom/unsupported.svg"
import suggested from "./custom/lightbulb.svg"
import candidate from "./custom/candidate.svg"
import contact_us from "./custom/contact_us.svg"

type SVGIcon = React.FC<React.SVGProps<SVGSVGElement> & { title?: string }>

const _icons = {
	add_image,
	photo,
	home,
	left,
	right,
	expand_right,
	expand_down,
	up,
	down,
	folder,
	folder_fill,
	grid_view,
	focus,
	undo,
	redo,
	download,
	star,
	star_fill,
	reset,
	add,
	remove,
	history,
	check,
	indeterminate,
	upload,
	calibrate,
	adjust,
	permission,
	crop,
	rotate_left,
	rotate_right,
	rotate_90_degrees_ccw,
	rotate_90_degrees_cw,
	flip_x,
	flip_y: flip_x,
	lock,
	lock_open,
	sort,
	check_circle,
	more,
	news,
	tutorials,
	support,
	projects,
	keyboard,
	hidden,
	visible,
	copy,
	error,
	delete: icon_delete,
	fullscreen,
	settings,
	no_color,
	no_color_filled,
	camera,
	invert_mask,
	masking,
	radial_mask,
	gradient_mask,
	sky_mask,
	brush_mask,
	brush_erase_mask,
	background_mask,
	subject_mask,
	people_mask,
	add_mask,
	subtract_mask,
	warning,
	center_mark,
	install_desktop,
	healing_before: hidden,
	healing_after: visible,
	manual,
	rename,
	cull,
	eye,
	help,
	stacks,
	drag,
	rated,
	thumb_up,
	thumb_down,
	kid_star,
	light,
	close,
	list,
	list_sort,
	search,
	play,
	arrow_up,
	arrow_down,
	arrow_back,
	arrow_forward,
	info,
	filter,
	no_photo,
	open_in_new,
	faces,
	refresh,

	// Custom icons
	backward,
	forward,
	to_front,
	to_back,
	splitscreen_right,
	compare,
	presets,
	film,
	diamond,
	locked,
	parametric_curves,
	star0,
	star1,
	star2,
	star3,
	star4,
	star5,
	star0_filled,
	star1_filled,
	star2_filled,
	star3_filled,
	star4_filled,
	star5_filled,
	move_left,
	move_right,
	youtube,
	format,
	style,
	color_clipping,
	pipette,
	healing,
	healing_selected,
	unflagged,
	flagged,
	rejected,
	unsupported,
	suggested,
	candidate,
	contact_us,
} as const

export type IconName = keyof typeof _icons

// SVG imports are typed as string by vite/client.d.ts, but vite-plugin-svgr
// transforms them into React components at build time.
export const icons = _icons as unknown as Record<IconName, SVGIcon>
